import React from 'react';
import {
  Button,
  FormControl,
  Divider,
  FormControlLabel,
  FormLabel,
  FormGroup,
  Checkbox,
  Input,
  Typography,
  Chip,
  TextField,
} from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setData } from '../../../redux';
import {
  removeDocumentStyle,
  addDocumentStyle,
  installationProtocolActionsWithNote,
} from '../constants';
import { sortByDate } from '../../../../helperFunctions';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import TransferToCellMaterials from '../../TransferToCellMaterials';
import DeinstalledDevicesDialog from './DeinstalledDevicesDialog';
import DeinstalledDevicesList from './DeinstalledDevicesList';
import MaterialsSell from '../../MaterialsSell';

export default () => {
  const data = useSelector(state => state.tasks.data);
  const startedTaskId = useSelector(state => state.tasks.taskStarted.taskId);
  const task = data.tasks.find(x => x.id === startedTaskId);

  if (!task) return null;
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const installationProtocol = task ? task.installationProtocol : null;
  const { installedServices, failedActions } = installationProtocol;

  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const fontSize = width <= 500 ? '4vw' : '20px';

  const installedServicesTexts = [
    // { name: 'installedService01', label: 'А1 Нет' },
    // { name: 'installedService02', label: 'А1 ТВ' },
    // { name: 'installedService03', label: 'Самостоятелно' },
    // { name: 'installedService04', label: 'В пакет' },
    { name: 'installedService01', label: 'Нова инсталация' },
    { name: 'installedService02', label: 'Подмяна на оборудване' },
  ];

  const failedActionTexts = [
    { name: 'failedAction01', label: 'Абонатът не е предоставил достъп' },
    { name: 'failedAction02', label: 'Абонатът е отказал инсталация без конкретна причина' },
    { name: 'failedAction03', label: 'Липса на техническа възможност' },
    {
      name: 'failedAction04',
      label: 'Абонатът отказва да бъде направена снимка на инсталираното оборудване',
    },
    { name: 'failedAction05', label: 'Други:' },
  ];

  const handleInstalledServicesChange = event => {
    const updatedInstalledServices = [...installedServices];
    const installedService = installedServices.find(i => i.name === event.target.name);
    updatedInstalledServices.splice(installedServices.indexOf(installedService), 1, {
      ...installedService,
      checked: event.target.checked,
    });

    const updatedTask = {
      ...task,
      installationProtocol: {
        ...installationProtocol,
        installedServices: updatedInstalledServices,
      },
    };

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, updatedTask);

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const handleInputChange = (event, elementName) => {
    const updatedInstallationProtocol = { ...installationProtocol };
    updatedInstallationProtocol[elementName] = event.target.value;

    const updatedTask = {
      ...task,
      installationProtocol: updatedInstallationProtocol,
    };

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, updatedTask);

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const handleFailedActionChange = event => {
    const updatedFailedActions = [...failedActions];
    const failedAction = failedActions.find(f => f.name === event.target.name);
    updatedFailedActions.splice(failedActions.indexOf(failedAction), 1, {
      ...failedAction,
      checked: event.target.checked,
    });

    const updatedTask = {
      ...task,
      installationProtocol: {
        ...installationProtocol,
        failedActions: updatedFailedActions,
      },
    };

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, updatedTask);

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  return (
    <>
      <Button
        variant="contained"
        style={
          installationProtocol && installationProtocol.open ? removeDocumentStyle : addDocumentStyle
        }
        onClick={() => {
          const updatedInstallationProtocol = { ...installationProtocol };
          updatedInstallationProtocol.open = !updatedInstallationProtocol.open;

          const updatedTask = {
            ...task,
            installationProtocol: updatedInstallationProtocol,
          };

          const updatedTasks = [...data.tasks];
          updatedTasks.splice(taskIndex, 1, updatedTask);

          dispatch(
            setData({
              ...data,
              tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
            })
          );

          // dispatch(setInstallationProtocol(updatedInstallationProtocol));
        }}
      >
        {installationProtocol && installationProtocol.open
          ? 'Премахни Протокол за инсталация'
          : 'Добави Протокол за инсталация'}
      </Button>
      {installationProtocol && installationProtocol.open ? (
        <>
          <div style={{ margin: '3px' }}>
            <TransferToCellMaterials />
          </div>
          <Chip
            style={{ margin: '10px', padding: '10px', fontSize }}
            avatar={<Add />}
            onClick={() => {
              const updatedInstallationProtocol = { ...installationProtocol };
              updatedInstallationProtocol.isDeinstalledDevicesDialogOpen = true;

              const updatedTask = {
                ...task,
                installationProtocol: updatedInstallationProtocol,
              };

              const updatedTasks = [...data.tasks];
              updatedTasks.splice(taskIndex, 1, updatedTask);

              dispatch(
                setData({
                  ...data,
                  tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
                })
              );
            }}
            clickable
            label="Добави деинсталирано оборудване"
          />
          <DeinstalledDevicesDialog />
          <DeinstalledDevicesList />
          {data?.sellMaterials?.length > 0 && (
            <div style={{ margin: '3px' }}>
              <MaterialsSell hasButtons={false} task={task} />
            </div>
          )}
          <FormControl style={{ marginTop: '10px' }} component="fieldset" variant="standard">
            <FormLabel
              style={{ marginTop: '10px', marginBottom: '10px', fontWeight: '900', color: 'black' }}
              component="legend"
            >
              Действия:
            </FormLabel>
            <FormGroup>
              {installedServicesTexts.map(x => {
                return (
                  <FormControlLabel
                    key={`label${x.name}`}
                    control={
                      <Checkbox
                        id={x.name}
                        checked={installedServices.find(i => i.name === x.name).checked}
                        onChange={handleInstalledServicesChange}
                        name={x.name}
                      />
                    }
                    label={x.label}
                  />
                );
              })}
            </FormGroup>
            <Divider style={{ marginBottom: '15px' }} />
            <FormGroup>
              <Typography>Сателитна чиния и крепежен комплект (брой):</Typography>
              <Input
                size="small"
                margin="none"
                onChange={e => handleInputChange(e, 'satelliteArray')}
              />
              <Typography>Моноблок вид:</Typography>
              <Input size="small" margin="none" onChange={e => handleInputChange(e, 'monoblock')} />
              <Typography>Видео кабели – HDMI, SCART, Композитен кабел:</Typography>
              <Input size="small" margin="none" onChange={e => handleInputChange(e, 'cables')} />
              <Typography>Коксиален кабел (метри):</Typography>
              <Input
                size="small"
                margin="none"
                onChange={e => handleInputChange(e, 'coaxialCable')}
              />
              <Typography>Други вложени материали:</Typography>
              <Input
                size="small"
                margin="none"
                onChange={e => handleInputChange(e, 'otherMaterials')}
              />
            </FormGroup>
            <Divider style={{ marginTop: '15px' }} />

            <FormLabel
              style={{ marginTop: '10px', marginBottom: '10px', fontWeight: '900', color: 'black' }}
              component="legend"
            >
              Инсталацията не е осъществена поради следните причини:
            </FormLabel>
            <FormGroup>
              {failedActionTexts.map(x => {
                return (
                  <FormControlLabel
                    key={`label${x.name}`}
                    control={
                      <Checkbox
                        id={x.name}
                        checked={failedActionTexts.find(i => i.name === x.name).checked}
                        onChange={handleFailedActionChange}
                        name={x.name}
                      />
                    }
                    label={x.label}
                  />
                );
              })}
            </FormGroup>
            <FormGroup>
              {failedActions.find(
                c => c.name === installationProtocolActionsWithNote.failedActionWithNote
              ) &&
              failedActions.find(
                c => c.name === installationProtocolActionsWithNote.failedActionWithNote
              ).checked ? (
                <TextField
                  label="Забележка"
                  value={installationProtocol.failedActionNote}
                  multiline
                  fullWidth
                  onChange={e => handleInputChange(e, 'failedActionNote')}
                  style={{ marginBottom: '15px' }}
                />
              ) : null}
            </FormGroup>
          </FormControl>
        </>
      ) : null}
    </>
  );
};
